import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: '16px',
        textAlign: 'center',
      }}
    >
      <span style={{ fontSize: '48px', lineHeight: 1 }}>404</span>
      <p style={{ margin: 0, color: 'var(--text-muted)', fontSize: '14px' }}>
        Page not found.
      </p>
      <Link
        to="/investigations"
        style={{
          color: 'var(--accent-light)',
          textDecoration: 'none',
          fontSize: '13px',
          fontWeight: 500,
        }}
      >
        ← Back to Investigations
      </Link>
    </div>
  )
}
